export default {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY,
  apiPlatform: process.env.REACT_APP_PLATFORM,
};
